import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { actions as editWorkingHoursActions } from '../../../redux/profiles/edit-working-hours';
import {
  loggedUserEmployeeIdSelector,
  targetUserEmployeeIdSelector,
} from '../../../redux/context/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  employeeId:
    loggedUserEmployeeIdSelector(state) || targetUserEmployeeIdSelector(state),
});

const mapDispatchToProps = {
  editWorkingHoursActions: editWorkingHoursActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/FieldSetList/enhance.js